export const CourseCenterRoutes = [{
  path: '/CourseCenter',
  component: () => import('./CourseCenter.vue'),
  meta: {
    crumbName: '测评课程',
  },
  children: [
    {
      path: '',
      name: '测评课程',
      component: () => import('../course.vue')
    }, {
      path: 'courseDetail/:guid?',
      name: '课程详情',
      component: () => import('../courseDetail.vue'),
      meta: {
        //标明是否需要登录后才能访问
        auth:false
      }
    }
  ]
}]



// WEBPACK FOOTER //
// ./src/pages/CourseCenter/router/CourseCenter.routes.js